import { SET_MODAL_STATE } from './modalsConstants';

export const setModalStateFor = (modalType, payload) => ({
  type: SET_MODAL_STATE,
  payload,
  modalType
});
